import React from 'react';
import ListViewRow from './ListViewRow';
import ListViewFilterBar from './ListViewFilterBar';

/**
 * ListViewTable - The main table structure with sorting headers and rows.
 */
export default function ListViewTable({
    sorted,
    sortConfig,
    handleSort,
    selectedIds,
    toggleSelect,
    toggleSelectAll,
    isConflictDetectionEnabled,
    isReadOnly,
    assignmentsForConflicts,
    absencesForConflicts,
    workers,
    vehicles,
    kolonnen,
    onAssignmentClick,
    onAssignmentDelete,
    onAssignmentHover,
    onAssignmentHoverEnd,
    filterProps
}) {
    const showConflicts = !!isConflictDetectionEnabled;

    const renderSortArrow = (key) =>
        sortConfig.key === key ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : '';

    return (
        <div className="leader-list-table-container">
            <table className="leader-list-table">
                <thead>
                    <tr>
                        <th className="checkbox-col">
                            <input 
                                type="checkbox" 
                                checked={selectedIds.length === (sorted.length || 0) && sorted.length > 0} 
                                onChange={e => toggleSelectAll(e.target.checked)}
                            />
                        </th>
                        {showConflicts && (
                            <th className="sortable conflict-col" onClick={() => handleSort('conflicts')} style={{ width: 40, textAlign: 'center' }} title="Konflikte">
                                {sortConfig.key === 'conflicts' ? (sortConfig.direction === 'asc' ? '⚠️↑' : '⚠️↓') : '⚠️'}
                            </th>
                        )}
                        <th className="sortable" onClick={() => handleSort('status')}>Status {renderSortArrow('status')}</th>
                        <th className="sortable" onClick={() => handleSort('project_name')}>Bezeichnung {renderSortArrow('project_name')}</th>
                        <th className="sortable" onClick={() => handleSort('location')}>Ort {renderSortArrow('location')}</th>
                        <th className="sortable" onClick={() => handleSort('start_datetime')}>Termin {renderSortArrow('start_datetime')}</th>
                        <th className="sortable" onClick={() => handleSort('kolonne')}>Kolonne {renderSortArrow('kolonne')}</th>
                        <th className="sortable" onClick={() => handleSort('workers')}>Mitarbeiter {renderSortArrow('workers')}</th>
                        <th className="sortable" onClick={() => handleSort('vehicles')}>Fahrzeuge {renderSortArrow('vehicles')}</th>
                        <th style={{ width: 40 }} title="Anmerkungen">Anm.</th>
                        <th style={{ width: isReadOnly ? 40 : 100 }}>{isReadOnly ? '' : 'Aktionen'}</th>
                    </tr>
                    
                    <ListViewFilterBar 
                        {...filterProps}
                        isConflictDetectionEnabled={showConflicts}
                        isReadOnly={isReadOnly}
                        allWorkers={workers}
                        allVehicles={vehicles}
                        kolonnen={kolonnen}
                    />
                </thead>
                <tbody>
                    {sorted.map(a => (
                        <ListViewRow 
                            key={a.id}
                            assignment={a}
                            isSelected={selectedIds.includes(a.id)}
                            onToggleSelect={toggleSelect}
                            isConflictDetectionEnabled={showConflicts}
                            assignmentsForConflicts={assignmentsForConflicts}
                            absencesForConflicts={absencesForConflicts}
                            workers={workers}
                            vehicles={vehicles}
                            kolonnen={kolonnen}
                            isReadOnly={isReadOnly}
                            onAssignmentClick={onAssignmentClick}
                            onAssignmentDelete={onAssignmentDelete}
                            onAssignmentHover={onAssignmentHover}
                            onAssignmentHoverEnd={onAssignmentHoverEnd}
                        />
                    ))}
                    {sorted.length === 0 && (
                        <tr>
                            <td colSpan={showConflicts ? 11 : 10} style={{ padding: '40px', color: '#94a3b8', fontStyle: 'italic' }}>
                                Keine Einsätze gefunden
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
